import { commonService } from '../../_services'
const geofenceService = commonService('api/v1/geofence')
// for debug
// let count: number = 0

export const makeUniqueProcId = userIds => {
  const l: string[] = []
  for (const id of userIds) {
    l.push(id.split('-')[0])
  }

  return 'geofence.' + l.join('.')
}

const initialState = {
  all: { items: [] },
  item: { monitor: [] },
  loading: false,
}

const deepCloneInitial = () => {
  return JSON.parse(JSON.stringify(initialState))
}

export const geofences = {
  namespaced: true,
  state: deepCloneInitial,
  actions: {
    async getAll(context: any): Promise<void> {
      context.commit('GET_ALL_REQUEST')

      return await geofenceService
        .getAll()
        .then(resp => {
          context.commit('GET_ALL_SUCCESS', resp.data)
        })
        .catch(errorMsg => {
          context.commit('GET_ALL_FAILURE')
          context.dispatch('common/setFlashMessage', { error: [errorMsg] }, { root: true })
        })
    },
    async addOne(context: any, data: any): Promise<void> {
      context.commit('ADD_REQUEST')

      return await geofenceService
        .addOne(data)
        .then(resp => {
          // Fetch just added data
          geofenceService.getOne(resp.data._id).then(singleData => {
            context.commit('ADD_ITEM_SUCCESS', singleData.data)
          })
          return Promise.resolve(resp.data)
        })
        .catch(errorMsg => {
          context.commit('REQUEST_ERROR')
          context.dispatch('common/setFlashMessage', { error: [errorMsg] }, { root: true })
          return Promise.reject(errorMsg)
        })
    },
    async updateOne(context: any, data: any): Promise<void> {
      context.commit('UPDATE_REQUEST')

      return await geofenceService
        .updateOne(data)
        .then(resp => {
          return geofenceService.getOne(resp.data._id).then(singleData => {
            context.commit('UPDATE_ITEM_SUCCESS', singleData.data)
            return Promise.resolve(singleData.data)
          })
        })
        .catch(errorMsg => {
          context.commit('REQUEST_ERROR')
          context.dispatch('common/setFlashMessage', { error: [errorMsg] }, { root: true })
          return Promise.reject(errorMsg)
        })
    },
    async deleteOne(context: any, data: any): Promise<void> {
      context.commit('DELETE_REQUEST')
      return await geofenceService
        .deleteOne(data._id)
        .then(resp => {
          context.commit('DELETE_ITEM_SUCCESS', data)
          return Promise.resolve(resp.data)
        })
        .catch(errorMsg => {
          context.commit('REQUEST_ERROR')
          context.dispatch('common/setFlashMessage', { error: [errorMsg] }, { root: true })
          return Promise.reject(errorMsg)
        })
    },
    async uploadFile(context: any, file: File): Promise<void> {
      context.commit('FILE_UPLOADING')
      return geofenceService
        .uploadFile(file)
        .then(resp => {
          context.commit('UPLOAD_FINISHED')
          return Promise.resolve(resp.data)
        })
        .catch(errorMsg => {
          context.commit('REQUEST_ERROR')
          context.dispatch('common/setFlashMessage', { error: [errorMsg] }, { root: true })
          return Promise.reject(errorMsg)
        })
    },
    async importCSV(context: any, file: File): Promise<void> {
      context.commit('CSV_UPLOADING')
      return geofenceService
        .importCSV(file)
        .then(resp => {
          context.commit('CSV_UPLOAD_FINISHED')
          // Reload list data
          context.dispatch('getAll')
          return Promise.resolve(resp.data)
        })
        .catch(errorMsg => {
          context.commit('REQUEST_ERROR')
          context.dispatch('common/setFlashMessage', { error: [errorMsg] }, { root: true })
          return Promise.reject(errorMsg)
        })
    },
    async getMonitor(context: any, data: any): Promise<void> {
      const { isLoading, ...params } = data

      // Stop refresh if user not active browser tab and user ids not have
      if (document.hidden || !params.user_ids || !params.user_ids.length) {
        return
      }

      if (isLoading) {
        context.commit('GET_ALL_REQUEST')
        return context.dispatch('getFullMonitor', params)
      } else {
        return context.dispatch('getSplitByUserIds', params)
      }
    },
    async getFullMonitor(context: any, options: any) {
      const processKey = makeUniqueProcId(options.user_ids)

      return await context.dispatch('getMonitorData', { processKey, params: options })
    },
    async getSplitByUserIds(context: any, options: any) {
      const isSplitFetch = true
      const usersListIds = options.user_ids as string[]

      const itemsEachFetch = 10
      const timeNeedToFetch = Math.ceil(usersListIds.length / itemsEachFetch)

      for (let index = 0; index < timeNeedToFetch; index++) {
        // 0 -> 10 ==== 10 -> 20 ==== 20, 30......
        const userIdsToFetch = usersListIds.slice(itemsEachFetch * index, itemsEachFetch + itemsEachFetch * index)
        const processKey = makeUniqueProcId(userIdsToFetch)

        await context.dispatch('getMonitorData', {
          processKey,
          params: { ...options, user_ids: userIdsToFetch },
          isSplitFetch,
        })
      }
    },
    async getMonitorData(context: any, options: any) {
      const { processKey, isSplitFetch, params } = options

      if ((window as any)[processKey]) {
        return Promise.resolve()
      }

      // Make a cache processing
      ;(window as any)[processKey] = true

      return await commonService('api/v1/geofence/monitor')
        .getAll(params)
        .then(resp => {
          /* tslint:disable-next-line */
          const currentGeofenceId = (window as any)['geofence_fetch_id']
          // keep for debug
          //   if ((count >= 4 && count <= 6) || (count >= 7 && count <= 10) || (count >= 12 && count <= 25)) {
          //     resp.data.map(item => {
          //       if (item.san_id === '106aa') {
          //         item.geo_ids = ['7e0f58f4-6306-11ec-81c4-0242ac110003']
          //         // item.geo_status = false
          //         item.measureded_at = new Date()
          //       }
          //     })
          //   } else {
          //     resp.data.map(item => {
          //       if (item.san_id === '108bf') {
          //         item.geo_ids = ['e686cbc2-22a3-11ec-b55c-0242ac110003']
          //         item.measureded_at = new Date()
          //       }
          //     })
          //   }

          //   if ((count >= 6 && count <= 16) || (count >= 18 && count <= 22)) {
          //     resp.data.map(item => {
          //       if (item.san_id === '1043c') {
          //         item.geo_ids = ['7e0f58f4-6306-11ec-81c4-0242ac110003']
          //         // item.geo_status = false
          //         item.measureded_at = new Date()
          //       }
          //     })
          //   }

          //   count++

          // Prevent case response return slower after change selected geofence
          if (currentGeofenceId && currentGeofenceId !== params.geofence_id && params.geofence_id !== 'all') {
            return
          }

          if (isSplitFetch) {
            context.commit('GET_SPLIT_MONITOR_SUCCESS', resp.data)
          } else {
            context.commit('GET_MONITOR', resp.data)
          }
        })
        .catch(errorMsg => {
          context.commit('GET_MONITOR_FAILURE')
          context.dispatch('common/setFlashMessage', { error: [errorMsg] }, { root: true })
        })
        .finally(() => {
          // Remove cache processing
          delete (window as any)[processKey]
        })
    },
  },
  mutations: {
    GET_ALL_REQUEST(state: any) {
      state.loading = true
    },
    GET_ALL_SUCCESS(state: any, allItems: any[]) {
      state.all = { items: allItems }
      state.loading = false
    },
    GET_ALL_FAILURE(state: any) {
      state.all = { items: [] }
      state.loading = false
    },
    GET_MONITOR(state: any, allItems: any[]) {
      state.item.monitor = allItems
      state.loading = false
    },
    GET_SPLIT_MONITOR_SUCCESS(state: any, respUsers) {
      state.loading = false
      if (!state.item.monitor.length) {
        state.item.monitor = respUsers
        return
      }

      state.item.monitor = state.item.monitor.map(tmp => {
        for (const user of respUsers) {
          if (user._id === tmp._id) {
            return user
          }
        }

        return tmp
      })
    },
    GET_MONITOR_FAILURE(state: any) {
      state.item.monitor = []
      state.loading = false
    },
    GET_REQUEST(state: any) {
      state.loading = true
    },
    GET_REQUEST_SUCCESS(state: any) {
      state.loading = false
    },
    ADD_REQUEST(state: any) {
      state.loading = true
    },
    UPDATE_REQUEST(state: any) {
      state.loading = true
    },
    DELETE_REQUEST(state: any) {
      state.loading = true
    },
    ADD_ITEM_SUCCESS(state: any, item: any) {
      state.all.items.push(item)
      state.loading = false
    },
    UPDATE_ITEM_SUCCESS(state: any, item: any) {
      state.all.items = state.all.items.map(tmp => {
        return tmp._id === item._id ? item : tmp
      })

      state.loading = false
    },
    DELETE_ITEM_SUCCESS(state: any, item: any) {
      const index = state.all.items.indexOf(item)
      state.all.items.splice(index, 1)
      state.loading = false
    },
    CSV_UPLOADING(state: any) {
      state.loading = true
    },
    CSV_UPLOAD_FINISHED(state: any, item: any) {
      state.loading = false
    },
    FILE_UPLOADING(state: any) {
      state.loading = true
    },
    UPLOAD_FINISHED(state: any, item: any) {
      state.loading = false
    },
    RESET_STATE(state: any) {
      Object.keys(initialState).forEach(key => {
        state[key] = JSON.parse(JSON.stringify(initialState[key]))
      })
    },
    REQUEST_ERROR(state: any) {
      state.loading = false
    },
  },
  getters: {
    canEdit: state => () => {
      return geofenceService.canEdit()
    },
    canDelete: state => () => {
      return geofenceService.canDelete()
    },
  },
}
